<script setup>
import { iconHref } from "~/utils/icons.js";

const { ariaLabel, name, size } = defineProps({
  ariaLabel: { default: null, type: String },
  name: { required: true, type: String },
  size: { default: 16, type: [String, Number] }
});
</script>

<template>
  <svg
    fill="currentColor"
    class="inline-block shrink-0 align-middle"
    :style="{ width: `${size}px`, height: `${size}px` }"
    :aria-label="ariaLabel"
    :aria-hidden="ariaLabel ? undefined : 'true'"
    :role="ariaLabel ? 'img' : undefined"
  >
    <use :href="iconHref(name)" />
  </svg>
</template>
